// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductWidget_wrapper__29Fpp"};